import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { IconService } from '@ess-front/shared';
import { WhatWeLove } from '@shared/models/be-experience.model';
import { Swiper, SwiperOptions } from 'swiper/types';

@Component({
  selector: 'ess-experience-love-slideshow',
  templateUrl: './experience-love-slideshow.component.html',
  styleUrls: ['./experience-love-slideshow.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ExperienceLoveSlideshowComponent implements OnInit {
  @Input() whatWeLoveGallery: WhatWeLove[] = [];
  config: SwiperOptions;
  paginationPointerLeft = 0;
  paginationPointerWidth = 0;
  private readonly DESKTOP_BREAKPOINT = '1024';

  nextArrowIcon: SafeHtml | null;
  prevArrowIcon: SafeHtml | null;

  constructor(
    private iconService: IconService,
    private changeDetectorRef: ChangeDetectorRef,
  ) {
    this.nextArrowIcon = this.iconService.getSVG('gallery_arrow_next');
    this.prevArrowIcon = this.iconService.getSVG('gallery_arrow_prev');
    this.config = this.getSwiperConfig();
  }

  ngOnInit(): void {
    this.setPaginationPointerWidth();
  }

  onSlideChange(activeIndex: number): void {
    this.paginationPointerLeft = this.paginationPointerWidth * activeIndex;
    this.changeDetectorRef.detectChanges();
  }

  onSwiperResize([{ pagination }]: [swiper: Swiper, breakpointParams: SwiperOptions]): void {
    pagination.destroy();
    pagination.init();
    pagination.render();
    pagination.update();
  }

  private getSwiperConfig(): SwiperOptions {
    return {
      breakpoints: {
        '0': {
          pagination: {
            clickable: false,
            el: '.slideshow-pagination-mobile',
            type: 'fraction',
            lockClass: 'locked',
            renderFraction: (currentClass, totalClass) => {
              return `<span><span class="${currentClass}"></span>/<span class="${totalClass}"></span></span>`;
            },
          },
        },
        [this.DESKTOP_BREAKPOINT]: {
          pagination: {
            clickable: false,
            el: '.slideshow-pagination',
            type: 'custom',
          },
        },
      },
      a11y: {
        enabled: false,
      },
      navigation: {
        disabledClass: 'disabled',
        nextEl: `.nav-next`,
        prevEl: `.nav-prev`,
      },
      slidesPerView: 1,
    };
  }

  private setPaginationPointerWidth() {
    this.paginationPointerWidth = 100 / this.whatWeLoveGallery.length;
  }
}
